import { render, staticRenderFns } from "./DialogCurvasFornecedor.vue?vue&type=template&id=225bfaa1"
import script from "./DialogCurvasFornecedor.vue?vue&type=script&lang=js"
export * from "./DialogCurvasFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports